import { __rest, __assign } from 'tslib';
import React, { forwardRef, useState, useEffect } from 'react';
import cn from 'classnames';
import { ButtonMobile } from '../../../../button/esm/mobile';
import { getDataTestId } from '../../../../shared/esm';
import { ReactCanvasPatternLock } from '@alfalab/react-canvas-pattern-lock';
import { THEME_STATE, DEFAULT_EXTRA_BOUNDS, OBSERVE_OPTIONS, OBSERVABLE_TOKENS } from '../../consts.js';
import { getSizes, getTheme, getColorByToken, getDefaultObserveTarget } from '../../utils.js';

var commonStyles = {"component":"pattern-lock__component_1dk9q","canvasContainer":"pattern-lock__canvasContainer_1dk9q","canvasInner":"pattern-lock__canvasInner_1dk9q","disabled":"pattern-lock__disabled_1dk9q","withForgotBtn":"pattern-lock__withForgotBtn_1dk9q","forgotBtn":"pattern-lock__forgotBtn_1dk9q"};
require('./index.css');

var BasePatternLock = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.observeTokens, observeTokens = _c === void 0 ? false : _c, _d = _a.observerParams, observerParams = _d === void 0 ? {} : _d, className = _a.className, dataTestId = _a.dataTestId, _e = _a.forgotCodeBtnText, forgotCodeBtnText = _e === void 0 ? 'Забыли код?' : _e, _f = _a.showForgotCodeBtn, showForgotCodeBtn = _f === void 0 ? false : _f, onForgotBtnClick = _a.onForgotBtnClick, _g = _a.extraBounds, extraBounds = _g === void 0 ? DEFAULT_EXTRA_BOUNDS : _g; _a.messageClassName; var hover = _a.hover, _h = _a.styles, styles = _h === void 0 ? {} : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, restProps = __rest(_a, ["observeTokens", "observerParams", "className", "dataTestId", "forgotCodeBtnText", "showForgotCodeBtn", "onForgotBtnClick", "extraBounds", "messageClassName", "hover", "styles", "disabled"]);
    var _k = useState(), params = _k[0], setParams = _k[1];
    useEffect(function () {
        var _a = getSizes(), elementSizes = _a.elementSizes, width = _a.width, height = _a.height;
        setParams({
            theme: getTheme(elementSizes),
            width: width,
            height: height,
        });
    }, []);
    useEffect(function () {
        var styleObserver = null;
        if (observeTokens) {
            var _a = observerParams.options, options = _a === void 0 ? OBSERVE_OPTIONS : _a, _b = observerParams.getTarget, getTarget = _b === void 0 ? getDefaultObserveTarget : _b;
            styleObserver = new MutationObserver(function () {
                return setParams(function (prevState) {
                    var _a = getSizes(), width = _a.width, height = _a.height, elementSizes = _a.elementSizes;
                    if (!prevState) {
                        return { theme: getTheme(elementSizes), width: width, height: height };
                    }
                    var prevBgColor = prevState.theme[THEME_STATE.INITIAL].colors.primary;
                    var themeChanged = prevBgColor !== getColorByToken(OBSERVABLE_TOKENS.PRIMARY);
                    if (themeChanged)
                        return __assign(__assign({}, prevState), { theme: getTheme(elementSizes) });
                    return prevState;
                });
            });
            styleObserver.observe(getTarget(), options);
        }
        return function () { return styleObserver === null || styleObserver === void 0 ? void 0 : styleObserver.disconnect(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observeTokens]);
    return (React.createElement("div", { className: cn(commonStyles.component, styles.component, className, (_b = {},
            _b[commonStyles.hidden] = !params,
            _b[commonStyles.withForgotBtn] = showForgotCodeBtn,
            _b[commonStyles.disabled] = disabled,
            _b)), "data-test-id": dataTestId },
        React.createElement("div", { className: commonStyles.canvasContainer },
            React.createElement("div", { className: commonStyles.canvasInner },
                React.createElement(ReactCanvasPatternLock, __assign({}, restProps, params, { ref: ref, rows: 3, cols: 3, justifyNodes: 'space-between', extraBounds: extraBounds, hover: hover })))),
        showForgotCodeBtn && (React.createElement(ButtonMobile, { view: 'transparent', className: cn(commonStyles.forgotBtn, styles.forgotBtn), onClick: onForgotBtnClick, dataTestId: getDataTestId(dataTestId, 'forgot-code-btn') }, forgotCodeBtnText))));
});
BasePatternLock.displayName = 'BasePatternLock';
ReactCanvasPatternLock.displayName = 'ReactCanvasPatternLock';

export { BasePatternLock };
